import React from 'react';
import { NAME_PAINT_SURFACES, namePaintStyle } from '../../../_helpers/namePaint.js';
import '../../../styles/NamePaint.css';

/**
 * A listener's name in their equipped name paint (Skins, mockup 33,
 * ENG-731), drawn from the paint's data for the `surface` it sits on. With no
 * paint, or one that can't be drawn, it is the plain name with
 * `fallbackClassName` (the standard username colour).
 */
const PaintedName = ({ name, paint, surface = NAME_PAINT_SURFACES.chat, className = '', fallbackClassName = '' }) => {
  const style = namePaintStyle(paint, surface);
  if (!style) {
    const plain = [className, fallbackClassName].filter(Boolean).join(' ');
    return <span className={plain || undefined}>{name}</span>;
  }
  return (
    <span className={[className, 'name-paint'].filter(Boolean).join(' ')} style={style} data-testid="painted-name">
      {name}
    </span>
  );
};

export default PaintedName;
